import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ScriptService } from './service/script.service';
import { Tooltip } from 'bootstrap';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { CookieService } from 'src/app/service/cookie.service';
import { AnalyticsService } from './analytics/services/analytics.service';


declare var $: any;
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'sr-login';
  pagepath = window.location.href;
  
  constructor(
    private router: Router, 
    private script: ScriptService,
    private route: ActivatedRoute,
    private cookies: CookieService,
    private analytics: AnalyticsService
  ) { 
    this.saveSmartLinkDetails();
  }

  ngOnInit(): void {
    //setting rel parameter in cookie
    this.setRelCookies();
    if(this.pagepath != 'https://qa-web-1.kartrocket.com/login' && this.pagepath != 'https://krmct002.kartrocket.com/login' && this.pagepath != 'https://app.shiprocket.in/login'){
        this.script.load('analytics', 'gtagsrc', 'gtag', 'gtagsrc_GA4', 'gtag_GA4', 'gtagsrc_GA4_NEW', 'gtag_GA4_NEW', 'conversion', 'facebook', 'gtm', 'widget').then(data => {
        // console.log('script loaded ', data);
        }).catch(error => console.log(error));
    }
    this.analytics.initialize();
  }
  setRelCookies(){
      const expirationDate = new Date(); 
      expirationDate.setDate(expirationDate.getDate() + 30); // Add 30 days

      const formattedDate = expirationDate;
      const urlParams = new URLSearchParams(window.location.search);
      let rel = urlParams.get('rel');
      if (rel) {
        let existingRel = this.cookies.getCookie('rel');
        if (existingRel) {
          // Append the new rel value to the existing rel value
          rel = existingRel + ',' + rel;
        }
        let domain = this.getMainDomain();
        document.cookie = `rel=${rel};domain=${domain};expires=${formattedDate}`;
      }
    }

  getMainDomain() {


    // Split the hostname by dots
    var host = window.location.hostname
    var parts = host.split('.');

    // Check if the hostname has subdomains
    if (parts.length > 2) {
        // Remove the subdomain and return the main domain
        return `.${parts.slice(1).join('.')}`
    }
    else{
      return `.${host}`
    }
}

  ngAfterViewInit(){
    new Tooltip('body', {
      selector: '[data-toggle="tooltip"]',
    });
    if((this.pagepath == 'https://qa-web-1.kartrocket.com/login') || (this.pagepath == 'https://krmct002.kartrocket.com/login') || (this.pagepath == 'https://app.shiprocket.in/login')){
      setTimeout(() => {
        this.script.load('analytics', 'gtagsrc', 'gtag', 'gtagsrc_GA4', 'gtag_GA4', 'gtagsrc_GA4_NEW', 'gtag_GA4_NEW', 'conversion', 'facebook', 'gtm', 'widget').then(data => {
        // console.log('script loaded ', data);
        }).catch(error => console.log(error));
      }, 1000);
    }
  }
  saveSmartLinkDetails():void{
    const urlParams = new URLSearchParams(window.location.search);
    let couponValue = urlParams.get('coupons');
    let amount = urlParams.get('amt')
    let quickRecharge:any = urlParams.get('qr')
    let QR = {}
    if( quickRecharge == 1)
    {
      QR['qr'] = quickRecharge

      if(couponValue)
      QR['coupons']=couponValue
      
      if(amount)
      QR['amount']=amount
  
  
    
  
      if(quickRecharge!=null){
        localStorage.setItem("QR",JSON.stringify(QR));
      }
    }
  }


}

